"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SubscriptionError;
(function (SubscriptionError) {
    SubscriptionError["database_operation_failed"] = "database_operation_failed";
    SubscriptionError["asset_does_not_exist"] = "asset_does_not_exist";
    SubscriptionError["account_does_not_exist"] = "account_does_not_exist";
    SubscriptionError["transaction_broadcast_failed"] = "transaction_broadcast_failed";
    SubscriptionError["subscription_to_author_failed"] = "subscription_to_author_failed";
    SubscriptionError["subscription_does_not_exist"] = "subscription_does_not_exist";
    SubscriptionError["blockchain_connection_failed"] = "blockchain_connection_failed";
    SubscriptionError["missing_options_arguments"] = "missing_options_arguments";
    SubscriptionError["syntactic_error"] = "syntactic_error";
    SubscriptionError["invalid_parameters"] = "invalid_parameters";
})(SubscriptionError = exports.SubscriptionError || (exports.SubscriptionError = {}));
var SubscriptionOptions = /** @class */ (function () {
    function SubscriptionOptions() {
        this.allowSubscription = false;
        this.subscriptionPeriod = 0;
        this.amount = 0;
        this.asset = null;
    }
    return SubscriptionOptions;
}());
exports.SubscriptionOptions = SubscriptionOptions;
//# sourceMappingURL=subscription.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/model/subscription.js
// module id = 229
// module chunks = 0